export enum TABS {
  ALL_ASSET = 'allAssets',
  PHOTO = 'photo',
  VIDEO = 'video',
  MUSIC = 'music',
  TEXT_OVERLAY = 'textOverlay'
}

export enum OrganizationAssetType {
  PHOTO = 'photo',
  VIDEO = 'video',
  AUDIO = 'audio'
}
